import React from "react";
import { Field } from "formik";
import { DropDownOption } from "../../controls/dropDown/types";
import DropDownMenu from "../../controls/dropDown/DropDownMenu";

interface Props {
  id: string;
  name: string;
  noSelection: string;
  startingValue: string;
  options: DropDownOption[];
  disabled?: boolean;
}

const FormDropdown = ({
  id,
  name,
  noSelection,
  startingValue,
  options,
  disabled = false
}: Props) => {
  return (
    <Field id={id} name={name} type="text">
      {({
        field: { value },
        form: { setFieldValue }
      }: {
        field: { value: string };
        form: {
          setFieldValue: (fieldName: string, value: string) => void;
        };
      }) => (
        <DropDownMenu
          noSelectionTitle={noSelection}
          options={options}
          onSelect={selection => setFieldValue(name, selection)}
          preSelectedOption={startingValue || value}
          disabled={disabled}
        />
      )}
    </Field>
  );
};

export default FormDropdown;
